// ==============================================================================================
//  APPLICATION AUTHORSHIP & RIGHTS NOTICE
//
//  Developed by: Gareth Morgan
//  Brand & Product: BuildMyChecks.co.uk
//  Ownership: Sole author and rights holder
//
//  ----------------------------------------------------------------------------------------------
//  NOTICE:
//  - This application and its related systems were designed, developed, and built solely
//    by Gareth Morgan.
//  - Gareth Morgan retains full authorship, intellectual property, and creative rights to
//    all Build My Checks branding, technology, source code, architecture, and design.
//  - No ownership, license, or implied rights are granted to any third party unless
//    explicitly agreed in writing by Gareth Morgan.
//  - Gareth Morgan is NOT responsible for future maintenance, updates, security patching,
//    or operational upkeep if this application is deployed, copied, or modified without
//    his written consent.
//  - Gareth Morgan reserves the right to:
//        Withdraw or disable access to the application or related services
//        Remove hosted, cloud-based, or linked services under his control
//        Revoke access to Build My Checksrelated assets, code, APIs, or integrations
//
//   2025 Gareth Morgan  BuildMyChecks.co.uk
//  Unauthorized use, alteration, copying, or redistribution without written consent
//  is strictly prohibited.
//
//  ----------------------------------------------------------------------------------------------
//  Build My Checks  ASCII Logo Signature
//  (Symbolic representation of BuildMyChecks.co.uk identity)
//
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................:-==++-.........:-:.............................................
// ...................................-*******:.......=*****+-.........................................
// ...................................=*******+:.....+*******=.........................................
// .........................::........+**********************=.........................................
// .......................-+***+-.:-++***********************=:.......:................................
// .....................-+*************************************+-..=+**+-..............................
// .....................:+*************+=-.............-++***************+:............................
// ......................:+********+=:.....................:=*************=............................
// .......................=******+:...........................-+********+-.............................
// ......................-*****+:...............................-+*****+-..............................
// ................:::::+****+-...................................=*****+..............................
// ...............+-......:=+-........+=.*%=......##:.:::.....:::..-*****=.............................
// ..............=*-*@%%%%@*.........-#*:#@=......@%::@@@*...*@@#...-+++++**++=-.......................
// .............:**-*@*..=@%.=#+..*#=-%#:#@=.=#%#+@%::@%%%-.=@%@#-##:..##:+*****:......................
// ..............-+-*@@%%@%+.+@*..#@==%#:#@==@%-:+@%::@#-@#:%#+%#.+@#.*@+-******=......................
// .................*@*..:#@++@*..#@==%#:#@=+@#...@%::@#.+@%%-=%#..%@#%#:+******+......................
// .................*@%##%@#.-%@%%@@==%#:#@=:#@%#%%%::@#.:#@*.=%#...%@%:=****+-:.......................
// ..................::........::.........:....::.....:....:......:-#@--***+:..........................
// ................:++:+@@@@@*.:@#:.....................#%=......:#%#-.+***+:..........................
// .............-+**+:#@*:.:+%+:@#-=+-...:=+=-....-+=-..#%=.:=-..-++-..+***+:..........................
// .............+***=-@%.......:@@#+#@#.+@#-+%#:+@%++@%:#%+*@#::%#--*-:*****+-.........................
// .............-***=:@%.......:@%:.-%%:%@%%%%%+#@=.....#@@@%:..#%@@%-=**+++++*+.......................
// ..............****-+%@*=+%@*:@%:.-%%.*@*-=*=.*@%==%#:#@+=@%=:++-+@*-+--===:+=.......................
// .................::::=***=:..++..:++..-+**=...:+**+:.=+-.:++:-*#*=::-:+***=::-++:...................
// ....................-****+=............................*#......+*****************=..................
// .....................=*****=.......+##+.:+##=....*+.-#-*#.**:..:+************++*=...................
// .....................+******+-....*%..:.%*.:%+..:%*.=%=*%%*..:--***********+:..-+:..................
// ....................+*********=:%=+%*+%-*%+*%-=#-#%*%@=*#:%*:+****+++****+=...=*****-...............
// ...................=**********+--::.::....::...:..::.:.:-::-:=***+:..=+*+:..:+******-...............
// ....................-******++*******+=-:............-=++****+=+***+:...:...=******+-:...............
// ......................-++-....=+***************************+=+-=****+:...-+******-..................
// ................................=**********************++-:....=******=:+********=..................
// ................................=**********************=......:+*****************+:.................
// ................................+*******=......+*******=........-+=.:=+****+-.-+-...................
// ................................:-=+***-........+******=..............=***+.........................
// .................................................--::...............................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
//
// ==============================================================================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import logo from '../../assets/image/logo_web.png';

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: 20 November 2025</p>

        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing and using Build My Checks ("the Service"), you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, you may not use the Service.
            </p>
            <p className="text-gray-700">
              Build My Checks is operated as a sole trader business in the United Kingdom.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Service Description</h2>
            <p className="text-gray-700 mb-4">
              Build My Checks provides digital checklist and inspection software as a subscription service. 
              The Service allows you to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Create custom digital checklists and inspection forms</li>
              <li>Conduct inspections and audits using mobile devices, tablets, or desktop computers</li>
              <li>Capture photos, signatures, and other evidence during inspections</li>
              <li>Generate PDF reports of completed inspections</li>
              <li>Manage team members and control access to features</li>
              <li>Store and retrieve inspection data securely in the cloud</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Subscription and Pricing</h2>
            <p className="text-gray-700 mb-4">
              Build My Checks is offered on a subscription basis at £5 per user per month. 
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Billing:</strong> You will be charged monthly based on the number of active users in your account</li>
              <li><strong>Payment:</strong> Payment is processed securely via Stripe. We accept major credit and debit cards</li>
              <li><strong>Auto-renewal:</strong> Your subscription automatically renews each month unless you cancel</li>
              <li><strong>Price changes:</strong> We reserve the right to change our pricing with 30 days' notice to existing customers</li>
              <li><strong>Free trial:</strong> New customers may be eligible for a free trial period. No credit card is required during the trial</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Cancellation and Refunds</h2>
            <p className="text-gray-700 mb-4">
              You may cancel your subscription at any time from your account dashboard or by contacting support@buildmychecks.co.uk.
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Cancellation:</strong> Cancellations take effect at the end of your current billing period. You will retain access until then</li>
              <li><strong>Refunds:</strong> We offer a 30-day money-back guarantee. If you cancel within 30 days of your first payment, we will issue a full refund</li>
              <li><strong>Pro-rata refunds:</strong> After the first 30 days, no refunds are issued for partial months. You may cancel to prevent future charges</li>
              <li><strong>Data export:</strong> Upon cancellation, you have 30 days to export your data. After this period, your data will be permanently deleted</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. User Responsibilities</h2>
            <p className="text-gray-700 mb-4">You agree to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Provide accurate and complete information when registering</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the Service only for lawful purposes and in compliance with all applicable laws</li>
              <li>Not share your account with unauthorized users</li>
              <li>Not attempt to reverse engineer, hack, or compromise the Service</li>
              <li>Not upload malicious content, viruses, or harmful code</li>
              <li>Not use the Service to violate the rights of others</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Data Ownership and Privacy</h2>
            <p className="text-gray-700 mb-4">
              <strong>Your data belongs to you.</strong> All checklists, inspections, photos, and other content you create 
              using Build My Checks remain your property.
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>We store your data securely using industry-standard encryption</li>
              <li>We will never sell or share your data with third parties without your consent</li>
              <li>You may export or delete your data at any time</li>
              <li>We comply with UK GDPR and Data Protection Act 2018</li>
              <li>See our <a href="/privacy" className="text-primary hover:underline">Privacy Policy</a> for full details on how we handle your data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Service Availability and Support</h2>
            <p className="text-gray-700 mb-4">
              We strive to maintain 99.9% uptime, but the Service is provided "as is" and we do not guarantee uninterrupted access.
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Maintenance:</strong> We may perform scheduled maintenance with advance notice</li>
              <li><strong>Support:</strong> Email support is available at support@buildmychecks.co.uk during UK business hours (Monday-Friday, 9am-5pm GMT)</li>
              <li><strong>Response time:</strong> We aim to respond to support requests within 24 hours on business days</li>
              <li><strong>Updates:</strong> We regularly update the Service to add features, fix bugs, and improve security</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">
              To the maximum extent permitted by law:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Build My Checks Ltd shall not be liable for any indirect, incidental, or consequential damages</li>
              <li>Our total liability is limited to the amount you paid in the 12 months prior to the claim</li>
              <li>We are not responsible for data loss due to user error, third-party actions, or force majeure</li>
              <li>You are responsible for maintaining backups of critical data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Modifications to Terms</h2>
            <p className="text-gray-700">
              We may update these Terms of Service from time to time. We will notify you of material changes by email 
              or via a notice in the Service. Continued use of the Service after changes take effect constitutes acceptance 
              of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law</h2>
            <p className="text-gray-700">
              These Terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive 
              jurisdiction of the courts of England and Wales.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contact Information</h2>
            <p className="text-gray-700 mb-2">
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <ul className="list-none text-gray-700 space-y-1">
              <li><strong>Email:</strong> support@buildmychecks.co.uk</li>
              <li><strong>Phone:</strong> Available via email request</li>
              <li><strong>Business Name:</strong> Build My Checks</li>
            </ul>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-gray-400">&copy; 2025 Build My Checks. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

// ----------------------------------------------------------------------------------------------
//  Build My Checks (c) 2025 Gareth Morgan - BuildMyChecks.co.uk
//  Solely designed, developed, and maintained by Gareth Morgan.
//  All intellectual property rights reserved.
//  No liability is accepted for unauthorised use, modification, deployment, or maintenance.
// ----------------------------------------------------------------------------------------------
